module.exports = require('./helpers/bundle-url').getBundleURL('2av5d') + "khotynenko.57fd1ce3.jpg";